import React from 'react';

/**
 * SectionCard — Single source of truth for the Dashboard container language.
 * Encodes the shared surface, border, radius, and padding tokens.
 *
 * Supports `as` prop for polymorphic rendering (e.g., motion.div).
 * Use `className` to override layout-specific concerns (flex, height, overflow, padding).
 */
const SectionCard = React.forwardRef(({ as: Tag = 'div', children, className = '', ...props }, ref) => {
  return (
    <Tag
      ref={ref}
      className={`vylo-section-card overflow-visible px-8 pb-7 pt-8 ${className}`}
      {...props}
    >
      {children}
    </Tag>
  );
});

SectionCard.displayName = 'SectionCard';

export default SectionCard;
